<script lang="ts" setup>
import {computed, onBeforeMount} from 'vue';
import Navbar from '@/components/company/NavBar.vue';
import {useRoute} from 'vue-router';
import getDefaultMeta from '@/utils/meta';
import {useAppTracking} from '@/composables/useAppTracking';

const route = useRoute();


const showFiler = computed(() => route?.meta?.showFilter || false);
const showCalendar = computed(() => route?.meta?.calendarOn || false);

const {initGoogleAnalytics} = useAppTracking();

const companyTermsUrl = computed(() => getDefaultMeta('settings.terms.url') as string || '');
const companyCancellationUrl = computed(() => getDefaultMeta('settings.cancellation.url') as string || '');

onBeforeMount(() => {
  console.dir('🚀 TheCompanyStoreLayout Initialized');
  initGoogleAnalytics();
});
</script>


<template>
  <v-layout>
    <v-main>
      <div>
        <Navbar :calendarOn="showCalendar" :filterOn="showFiler"/>

        <div id="main-tenant-content" class="flex-auto w-full min-w-0 lg:static lg:max-h-full lg:overflow-visible bg-gray-100" style="min-height: 2000px">
          <slot>
            <router-view name="default"/>
          </slot>
        </div>

        <!-- Footer -->
        <footer
          v-if="companyTermsUrl.trim() || companyCancellationUrl.trim()"
          class="flex flex-wrap justify-center gap-4 px-4 py-6 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-sm text-gray-600 dark:text-gray-300"
        >
          <a
            v-if="companyTermsUrl.trim()"
            :href="companyTermsUrl"
            class="transition hover:text-blue-600 dark:hover:text-blue-400 underline-offset-2 hover:underline"
            target="_blank"
          >
            Terms of Service
          </a>

          <a
            v-if="companyCancellationUrl.trim()"
            :href="companyCancellationUrl"
            class="transition hover:text-blue-600 dark:hover:text-blue-400 underline-offset-2 hover:underline"
            target="_blank"
          >
            Cancellation Policy
          </a>
        </footer>

      </div>
    </v-main>
  </v-layout>
</template>